<div class="theme-menu-container">
    <div class="theme-menu-section">
      <toolbar-grid-theme></toolbar-grid-theme>
    </div>
  
    <div class="theme-menu-divider"></div>
  
    <div class="theme-menu-section">
      <toolbar-grid-sidebar></toolbar-grid-sidebar>
    </div>
  </div>